import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteCategory,
    getCurrentCategory,
    resetDeleteCategoryStatus
} from "../../store/reducers/CategoriesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteCategoryScreenProps {
}

export const DeleteCategoryScreen: React.FC<DeleteCategoryScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const categoriesState = useAppSelector(state => state.categories);
    const requestStatus: RequestStatus = categoriesState.deleteCategoryStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupid', url: '/categories'},
        {text: 'Grupi kustutamine', url: `/categories/${id}/delete`},
    ];

    useEffect(() => {
        dispatch(resetDeleteCategoryStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteCategory({id}));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentCategory({id}));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Grupp kustutatud</h2>
                </div>
            </div>
        )
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: 'center'}}>
                <div>
                    <h2>
                        Oled kindel, et soovid grupi
                        tüübi <em>{categoriesState?.currentCategory?.name ?? ''}</em> kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                          <span>
                            <strong>Jah</strong>
                          </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );

}